import React from "react";
import { UserCog, X, AlertTriangle } from "lucide-react";
import { safeUserLabel } from "../../utils/adminLevelUtils";

/**
 * Shown before creating a personal configuration for a user who currently
 * inherits a shared admin level: "This will create a personal configuration
 * copied from {level}". Confirming calls POST /admin-levels/for-user/:userId.
 */
const ConfirmPersonalModal = ({ user, levelName, onConfirm, onClose, styles, theme, t }) => {
  if (!user) return null;

  return (
    <div style={styles.modal} onClick={onClose}>
      <div
        style={{ ...styles.modalContent, maxWidth: "440px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.modalHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{
              width: "40px", height: "40px", borderRadius: "12px",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: theme === "dark" ? "rgba(46,124,186,0.2)" : "rgba(46,124,186,0.1)",
            }}>
              <UserCog size={20} style={{ color: "#2e7cba" }} />
            </span>
            <h3 style={{ ...styles.modalTitle, fontSize: "18px" }}>{t.confirmPersonalTitle}</h3>
          </div>
          <button onClick={onClose} style={styles.iconButton} type="button">
            <X size={18} style={{ color: theme === "dark" ? "#94a3b8" : "#64748b" }} />
          </button>
        </div>

        <p style={{
          fontSize: "13.5px", lineHeight: 1.7, margin: "0 0 8px",
          color: theme === "dark" ? "#cbd5e1" : "#475569",
        }}>
          <strong>{safeUserLabel(user)}</strong> — {t.confirmPersonalBefore}{" "}
          <strong style={{ color: "#2e7cba" }}>{levelName}</strong>.
        </p>
        {/* explicit reassignment warning: continuing removes the user from the shared level */}
        <div style={{
          display: "flex", alignItems: "flex-start", gap: "10px",
          padding: "12px 14px", borderRadius: "12px", margin: "0 0 24px",
          background: theme === "dark" ? "rgba(217,119,6,0.14)" : "rgba(217,119,6,0.08)",
          border: `1px solid ${theme === "dark" ? "rgba(217,119,6,0.35)" : "rgba(217,119,6,0.25)"}`,
        }}>
          <AlertTriangle
            size={16}
            style={{ color: theme === "dark" ? "#fbbf24" : "#d97706", flexShrink: 0, marginTop: "2px" }}
          />
          <p style={{
            fontSize: "12.5px", lineHeight: 1.6, margin: 0,
            color: theme === "dark" ? "#fcd34d" : "#92400e",
          }}>
            {t.confirmPersonalAfter}
          </p>
        </div>

        <div style={styles.modalFooter}>
          <button
            type="button"
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={onClose}
          >
            {t.cancel}
          </button>
          <button
            type="button"
            style={{ ...styles.button, ...styles.primaryButton }}
            onClick={onConfirm}
          >
            {t.continueBtn}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPersonalModal;
